import React, { useState, useEffect, useRef, useCallback } from 'react';

const ScrollProgressBar = () => {
  const [scrollProgress, setScrollProgress] = useState(0);
  const requestRef = useRef();

  // Ultra-smooth progress update using requestAnimationFrame
  const updateProgress = useCallback(() => {
    // Calculate scroll progress with high precision
    const scrollTop = window.scrollY;
    const docHeight = document.body.scrollHeight - window.innerHeight;
    const progress = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
    
    // Update state with immediate value for maximum responsiveness
    setScrollProgress(progress);
    
    requestRef.current = requestAnimationFrame(updateProgress);
  }, []);

  useEffect(() => {
    requestRef.current = requestAnimationFrame(updateProgress);
    return () => {
      if (requestRef.current) {
        cancelAnimationFrame(requestRef.current);
      }
    };
  }, [updateProgress]);

  return (
    <div className="fixed top-0 left-0 w-full h-1.5 z-50">
      <div 
        className="h-full bg-gradient-to-r from-cyan-400 to-indigo-500"
        style={{ 
          width: `${scrollProgress}%`,
          transition: 'width 50ms ease-out'
        }}
      />
    </div>
  );
};

export default ScrollProgressBar;